angular.module('dialog-manager',[
    'ngLodash',
    'angularModalService',
    'sod-logger'
]);